module.exports = __webpack_public_path__ + "img/business-needs.f17c29fb.png";